module.exports = __webpack_public_path__ + "media/images/excel-8e1b1732.png";